import ActiveCall from './ActiveCall.svg';
import AddUser from './AddUser.svg';
import AddressBook from './AddressBook.svg';
import AgentPanel from './AgentPanel.svg';
import ArrowDown from './ArrowDown.svg';
import ArrowDownRight from './ArrowDownRight.svg';
import ArrowUp from './ArrowUp.svg';
import ArrowUpRight from './ArrowUpRight.svg';
import ArrowsRotate from './ArrowsRotate.svg';
import Backspace from './Backspace.svg';
import Briefcase from './Briefcase.svg';
import CallForward from './CallForward.svg';
import CallInbound from './CallInbound.svg';
import CallTo from './CallTo.svg';
import Camera from './Camera.svg';
import Check from './Check.svg';
import CheckCircle from './CheckCircle.svg';
import ChevronDown from './ChevronDown.svg';
import ChevronUp from './ChevronUp.svg';
import CircleDot from './CircleDot.svg';
import Clock from './Clock.svg';
import Close from './Close.svg';
import CloudPureLogo from './CloudPureLogo.svg';
import ColdTransferFrom from './ColdTransferFrom.svg';
import ColdTransferTo from './ColdTransferTo.svg';
import Copy from './Copy.svg';
import Crown from './Crown.svg';
import Delete from './Delete.svg';
import Dialpad from './Dialpad.svg';
import Dice from './Dice.svg';
import DoubleLeftRightArrow from './DoubleLeftRightArrow.svg';
import Envelope from './Envelope.svg';
import Ethernet from './Ethernet.svg';
import ExclamationMark from './ExclamationMark.svg';
import EyeOff from './EyeOff.svg';
import EyeOn from './EyeOn.svg';
import FaceSmileWink from './FaceSmileWink.svg';
import Favorite from './Favorite.svg';
import File from './File.svg';
import FilterList from './FilterList.svg';
import FolderGear from './FolderGear.svg';
import FollowMe from './FollowMe.svg';
import GearCode from './GearCode.svg';
import HangUp from './HangUp.svg';
import Help from './Help.svg';
import HelpCenter from './HelpCenter.svg';
import Hold from './Hold.svg';
import Home from './Home.svg';
import IncomingCall from './IncomingCall.svg';
import Information from './Information.svg';
import Key from './Key.svg';
import LeftArrow from './LeftArrow.svg';
import LeftRightArrow from './LeftRightArrow.svg';
import Logout from './Logout.svg';
import MadeByWTG from './MadeByWTG.svg';
import Merge from './Merge.svg';
import Message from './Message.svg';
import Microphone from './Microphone.svg';
import MicrophoneSlash from './MicrophoneSlash.svg';
import Minus from './Minus.svg';
import MobileRetro from './MobileRetro.svg';
import MugHot from './MugHot.svg';
import OutgoingCall from './OutgoingCall.svg';
import Pause from './Pause.svg';
import Pencil from './Pencil.svg';
import Phone from './Phone.svg';
import PhoneOffice from './PhoneOffice.svg';
import PickUp from './PickUp.svg';
import PlayCircle from './PlayCircle.svg';
import Plus from './Plus.svg';
import Recording2 from './Recording2.svg';
import Remove from './Remove.svg';
import RightArrow from './RightArrow.svg';
import Search from './Search.svg';
import Secretary from './Secretary.svg';
import SlashForward from './SlashForward.svg';
import Spinner from './Spinner.svg';
import Star from './Star.svg';
import StarOutlined from './StarOutlined.svg';
import Stop from './Stop.svg';
import Switchboard from './Switchboard.svg';
import Upload from './Upload.svg';
import User from './User.svg';
import UserGroup from './UserGroup.svg';
import Voicemail from './Voicemail.svg';
import WarmTransferFrom from './WarmTransferFrom.svg';
import WarmTransferTo from './WarmTransferTo.svg';
import XMark from './X-Mark.svg';
import ChefSec from './chef-sec.svg';
import Recording from './recording.svg';

export const Icon = {
  ActiveCall: ActiveCall,
  AddUser: AddUser,
  AddressBook: AddressBook,
  AgentPanel: AgentPanel,
  ArrowDown: ArrowDown,
  ArrowDownRight: ArrowDownRight,
  ArrowUp: ArrowUp,
  ArrowUpRight: ArrowUpRight,
  ArrowsRotate: ArrowsRotate,
  Backspace: Backspace,
  Briefcase: Briefcase,
  CallForward: CallForward,
  CallInbound: CallInbound,
  CallTo: CallTo,
  Camera: Camera,
  Check: Check,
  CheckCircle: CheckCircle,
  ChevronDown: ChevronDown,
  ChevronUp: ChevronUp,
  CircleDot: CircleDot,
  Clock: Clock,
  Close: Close,
  CloudPureLogo: CloudPureLogo,
  ColdTransferFrom: ColdTransferFrom,
  ColdTransferTo: ColdTransferTo,
  Copy: Copy,
  Crown: Crown,
  Delete: Delete,
  Dialpad: Dialpad,
  Dice: Dice,
  DoubleLeftRightArrow: DoubleLeftRightArrow,
  Envelope: Envelope,
  Ethernet: Ethernet,
  ExclamationMark: ExclamationMark,
  EyeOff: EyeOff,
  EyeOn: EyeOn,
  FaceSmileWink: FaceSmileWink,
  Favorite: Favorite,
  File: File,
  FilterList: FilterList,
  FolderGear: FolderGear,
  FollowMe: FollowMe,
  GearCode: GearCode,
  HangUp: HangUp,
  Help: Help,
  HelpCenter: HelpCenter,
  Hold: Hold,
  Home: Home,
  IncomingCall: IncomingCall,
  Information: Information,
  Key: Key,
  LeftArrow: LeftArrow,
  LeftRightArrow: LeftRightArrow,
  Logout: Logout,
  MadeByWTG: MadeByWTG,
  Merge: Merge,
  Message: Message,
  Microphone: Microphone,
  MicrophoneSlash: MicrophoneSlash,
  Minus: Minus,
  MobileRetro: MobileRetro,
  MugHot: MugHot,
  OutgoingCall: OutgoingCall,
  Pause: Pause,
  Pencil: Pencil,
  Phone: Phone,
  PhoneOffice: PhoneOffice,
  PickUp: PickUp,
  PlayCircle: PlayCircle,
  Plus: Plus,
  Recording2: Recording2,
  Remove: Remove,
  RightArrow: RightArrow,
  Search: Search,
  Secretary: Secretary,
  SlashForward: SlashForward,
  Spinner: Spinner,
  Star: Star,
  StarOutlined: StarOutlined,
  Stop: Stop,
  Switchboard: Switchboard,
  Upload: Upload,
  User: User,
  UserGroup: UserGroup,
  Voicemail: Voicemail,
  WarmTransferFrom: WarmTransferFrom,
  WarmTransferTo: WarmTransferTo,
  XMark: XMark,
  ChefSec: ChefSec,
  Recording: Recording,
};

export type IconType = keyof typeof Icon;
